import { render } from "./PopUpForm.vue?vue&type=template&id=5d36030e&scoped=true"
import script from "./PopUpForm.vue?vue&type=script&lang=js"
export * from "./PopUpForm.vue?vue&type=script&lang=js"

import "./PopUpForm.vue?vue&type=style&index=0&id=5d36030e&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d36030e"]])

export default __exports__